import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-slider1',
  templateUrl: './home-slider1.component.html',
  styleUrls: ['./home-slider1.component.css']
})
export class HomeSlider1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
